module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/account/pending-invoice/pending-invoice.component.css
// module id = ./src/app/account/pending-invoice/pending-invoice.component.css
// module chunks = main